import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    registerGiftCard,
    RegisterGiftCardFnPayload,
} from '../helpers/register-gift-card';

export type RegisterGiftCardFn = (
    payload: RegisterGiftCardFnPayload,
) => Promise<{
    giftCardAmount: number;
    giftCardTokenId: string;
}>;

export function initRegisterGiftCardFn({
    dependencies,
    countryCodeDefault,
}: DomainInitPayload): RegisterGiftCardFn {
    return async (payload: RegisterGiftCardFnPayload) => {
        const { giftCardAmount, giftCardTokenId } = await registerGiftCard(
            dependencies,
            {
                country: countryCodeDefault.toUpperCase() as 'US' | 'CA',
                ...payload,
            },
        );
        return {
            giftCardAmount,
            giftCardTokenId,
        };
    };
}
